import axios from 'axios';

// 创建独立的 axios 实例用于 cloud API
export const cloudAction = axios.create({
    // timeout: 10000, // 超时时间
});

// Cloud API 响应拦截器
cloudAction.interceptors.response.use(
    // 成功响应处理
    function(response) {
        // Cloud API 响应格式: {code, data: {total, data: []}, msg} 或 {success, data, errorMsg}
        // 也兼容学海 front: {result, code:"0", message, data}
        const { code, data, msg, message, success, errorMsg, result } = response.data;
        
        // 兼容多种成功判断条件：code === 0/"0" 或 code === 200 或 success === true 或 result === SUCCESS
        if (
            code === 0 ||
            code === "0" ||
            code === 200 ||
            code === "200" ||
            success === true ||
            result === "SUCCESS"
        ) {
            // 成功，返回完整响应对象
            // data 可能是数组，也可能是对象 {total, data: []}，也可能是原始对象（如 historyAtlasDetail）
            const responseData = response.data.data;
            if (Array.isArray(responseData)) {
                // 直接返回数组的情况（如列表接口）
                return {
                    data: responseData,
                    total: responseData.length,
                    page: 1
                };
            } else if (responseData && typeof responseData === 'object' && !Array.isArray(responseData)) {
                // 对象结构: {total, current, data: []} 或 {list: [], ...}（如 historyAtlasDetail）
                if (responseData.data !== undefined) {
                    // 标准分页结构: {total, current, data: []}
                    return {
                        data: responseData.data || [],
                        total: responseData.total || 0,
                        page: responseData.current || 1
                    };
                } else {
                    // 非标准结构（如 historyAtlasDetail），返回原始对象
                    return responseData;
                }
            } else {
                return {
                    data: [],
                    total: 0,
                    page: 1
                };
            }
        } else {
            // 失败，返回错误信息
            return Promise.reject(new Error(msg || message || errorMsg || `请求失败，错误码：${code}`));
        }
    },
    // 失败响应处理
    function(error) {
        const msg = error.response?.data?.msg || error.message || '请求失败';
        return Promise.reject(new Error(msg));
    }
);







